import { useEffect } from 'react';

/**
 * Closes the open sidebar flyout (`activeMenu`) on a click outside the sidebar
 * (`sidebarRef`) or on Escape.
 */
export default function useFlyoutDismiss(activeMenu, setActiveMenu, sidebarRef) {
  useEffect(() => {
    if (!activeMenu) return;
    const onDown = (e) => {
      if (sidebarRef.current && !sidebarRef.current.contains(e.target)) setActiveMenu(null);
    };
    const onKey = (e) => {
      if (e.key === 'Escape') setActiveMenu(null);
    };
    document.addEventListener('mousedown', onDown);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDown);
      document.removeEventListener('keydown', onKey);
    };
  }, [activeMenu, setActiveMenu, sidebarRef]);
}
